/*
 * ROUTE_META_PARAMS - names of params used on route.meta to control routes visibility and display
 * All below properties are optional and have default values
 *
 * @property {?boolean}  HIDDEN_IN_SEARCH false - indicates that route should not be visible in settings search
 * @property {?boolean}  HIDDEN_IN_PRODUCTION false - indicates that route should only be visible in development mode
 * @property {?string}   FEATURE_FLAG null - feature flag used to toggle route's visibility in settings and settings search
 * @property {?string}   ACCESS_LEVEL null - minimum access level required to enter the route
 * @property {?string}   ACCESS_LEVEL_PERMISSION null - access level permission required to enter the route
 * @property {?function} SHOULD_BE_VISIBLE null - takes vuex store as parameter, returns boolean indicating whether route should be visible
 * @property {?boolean}  DARK false - controls whether route setting tile should be dark or not (logout only)
 * @property {?boolean}  RIGHT_ICON false - icon displayed on settings tile right side (logout only)
 * @property {?function} STATUS_GETTER null - optional synchronous callback, should return object like: `{ value: /b-status props./ }`
 * @property {?function} ON_TILE_CLICK null - optional callback, used to customice settings tile click action for this route
 * @property {?boolean}  NO_INDEX_VIEW false - informs, that this route do NOT have its own settings index view
 * @property {?boolean}  SEARCH_IS_VISIBLE false - informs, that search input should be visible in layout
 * @property {?string}   SEARCH_PLACEHOLDER null - optional placeholder in search input
 * @property {?boolean}  IS_TILES_VIEW false - informs, that we should show tiles or router-view
 *
 * !IMPORTANT!
 *
 * If "noIndexView" is set to `true` you should probably also set "HIDDEN_IN_SEARCH" to `true` also, because in "search results mode" tile is non-clickable.
 *
 * More properties (not defined in the object below):
 *
 * @property {string} "title" null - translated route title - route's header & title on route settings tile - translated value used for settings' search
 * @property {string} "subtitle" null - translated route subtitle - route's subheader & subtitle - not used for settings' search
 * @property {?object} "defaultSubroute" null - contains child route name which we will be redirected to whenever entering this route
 * @property {?string} "hintKey" null - hey of hint that should be displayed when entering the route
 * @property {?string} "icon" null - route icon displayed on settings tile
 * @property {?string} "backgroundIcon" null - icon displayed on settings route background
 * @property {?boolean} "useSmartlook" false - controls whether route should be recorded in smartlook or not
 */
export const ROUTE_META_PARAMS = {
  HIDDEN_IN_SEARCH: 'hiddenInSearch',

  HIDDEN_IN_PRODUCTION: 'hiddenInProduction',

  FEATURE_FLAG: 'featureFlag',

  FEATURE_FLAG_EPPO: 'featureFlagEppo',

  ACCESS_LEVEL: 'accessLevel',

  ACCESS_LEVEL_PERMISSION: 'accessLevelPermission',

  SHOULD_BE_VISIBLE: 'shouldBeVisible',

  DARK: 'dark',

  RIGHT_ICON: 'rightIcon',

  STATUS_GETTER: 'statusGetter',

  ON_TILE_CLICK: 'onTileClick',

  NO_INDEX_VIEW: 'noIndexView',

  SEARCH_IS_VISIBLE: 'searchIsVisible',

  SEARCH_PLACEHOLDER: 'searchPlaceholder',

  IS_TILES_VIEW: 'isTilesView',
}
